import { DynamoNode } from "dynamo-models";

import React from "react";

import { NodeProps } from "..";
import { IEditorState, EditorMode } from "../..";
import { AbsComponentFactory } from "../factories";
import { Dispatch } from "redux";
import { doArrangeNode, doSetSelectedNode } from "../../redux";

export class DynComponent<TNode extends DynamoNode> extends React.Component<NodeProps<TNode>> {
}

export const TYPE = "node";

export const getFactory = (props: NodeProps<DynamoNode>): AbsComponentFactory => props.mode === EditorMode.Edit ? props.factory : props.previewFactory;

export const stateToProps = (state: IEditorState) => ({ 
    spacing: state.spacing,
    mode: state.mode,
    MetaNode: state.container,
    selectedNodeId: state.selectedNode !== undefined ? state.selectedNode.nodeId : undefined,
    hasUnsavedChanges: state.history.hasChanges(),
});

export const dispatchToProps = (dispatch) => ({
    getOnDrop: (props: NodeProps<DynamoNode>) => (droppable: any, index: number) => {
        const droppedNode = droppable as DynamoNode;
        const droppedNodeParent = props.MetaNode.tryFindParentOf(droppedNode.nodeId);

        if (droppedNodeParent === undefined) {
            return;
        }

        dispatch(doArrangeNode(droppedNode, droppedNodeParent, index));
    }
})
